/* Playmo Generation · animación de aparición al hacer scroll.
   Solo con body.pg-animate y sin «reducir movimiento». Nada se mueve en bucle. */
(() => {
  const body = document.body;
  if (!body || !body.classList.contains('pg-animate')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const SELECTOR = [
    '.pg-section-head',
    '.pg-grid > li',
    '.pg-trust__item',
    '.pg-shop__copy',
    '.pg-shop__collage',
    '.pg-shop__process-head',
    '.pg-process',
    '.pg-swatch',
    '.pg-collist__grid > li',
    '.pg-splitcards__card',
    '.pg-logos__cell',
    '.pg-accordion',
    '.pg-cta__titles',
    '.pg-cta__body',
    '.pg-blog__featured',
    '.pg-blog__grid > li',
    '.pg-phero__text',
    '.pg-phero__media',
    '.pg-contact__card',
    '.pg-contact__panel',
  ].join(',');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const prepare = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.classList.contains('pg-reveal')) return;
      // Escalonado dentro de cada rejilla (máx. 6 pasos)
      const siblings = el.parentElement ? Array.from(el.parentElement.children) : [el];
      const index = Math.min(siblings.indexOf(el), 5);
      el.style.setProperty('--pg-delay', `${Math.max(index, 0) * 70}ms`);
      el.classList.add('pg-reveal');
      // Lo que ya está en pantalla al cargar aparece enseguida
      observer.observe(el);
    });
  };

  document.documentElement.classList.add('pg-js-reveal');
  prepare();

  // Contenido que llega después (recomendaciones, editor de temas)
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((node) => node.nodeType === 1 && prepare(node.parentElement || document)));
  }).observe(document.querySelector('main') || body, { childList: true, subtree: true });

  // En el editor, mostrar todo al seleccionar una sección
  document.addEventListener('shopify:section:select', (event) =>
    event.target.querySelectorAll('.pg-reveal').forEach((el) => el.classList.add('is-visible'))
  );
})();

/* Playmo Generation · dificultar la descarga de fotos (Ajustes del tema › Dificultar la descarga de fotos).
   Sin menú contextual ni arrastre sobre imágenes. No es una protección real. */
(() => {
  if (!document.body || !document.body.classList.contains('pg-protect-img')) return;
  const onImage = (event) => event.target instanceof Element && event.target.closest('img, picture, .pg-media, video');
  document.addEventListener('contextmenu', (event) => {
    if (onImage(event)) event.preventDefault();
  });
  document.addEventListener('dragstart', (event) => {
    if (onImage(event)) event.preventDefault();
  });
})();
